export default {
	install(Vue) {

	}
}
